export const captchaTypes = {
    CAPTCHA_GET_START: '[Captcha] GET_START',
    CAPTCHA_GET_COMPLETE: '[Captcha] GET_COMPLETE',
    CAPTCHA_GET_ERROR: '[Captcha] GET_ERROR',
}